var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNextPageDisabled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.79881 2.9041C14.1007 2.9041 17.6027 6.40609 17.6027 10.708C17.6027 15.0099 14.1007 18.5119 9.79881 18.5119C5.49691 18.5119 1.99492 15.0099 1.99492 10.708C1.99492 6.40609 5.49691 2.9041 9.79881 2.9041ZM9.79881 0.953125C4.41412 0.953125 0.0439453 5.3233 0.0439453 10.708C0.0439453 16.0927 4.41412 20.4628 9.79881 20.4628C15.1835 20.4628 19.5537 16.0927 19.5537 10.708C19.5537 5.3233 15.1835 0.953125 9.79881 0.953125ZM10.7743 10.708V6.80604H8.82332V10.708H5.89686L9.79881 14.6099L13.7008 10.708H10.7743Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextPageDisabled);
export default __webpack_public_path__ + "static/media/next-page-disabled.e9675b891037a876f4844775940c65f6.svg";
export { ForwardRef as ReactComponent };